import React, { useState, useEffect } from 'react';
import * as sb from '../../services/supabaseClient';

const AdminTools = ({ onShowNotification, isAdmin }) => {
  const [admins, setAdmins] = useState([]);
  const [newAdminUid, setNewAdminUid] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');

  const loadAdmins = async () => {
    try {
      const list = await sb.fetchAdmins();
      setAdmins(list || []);
    } catch (e) {
      console.error('No se pudieron cargar admins', e);
    }
  };

  useEffect(() => {
    loadAdmins();
  }, []);

  const addAdminByUid = async () => {
    if (!newAdminUid) return setMessage('Introduce un UID');
    setBusy(true); setMessage('');
    try {
      await sb.addAdminRemote({ id: newAdminUid });
      setMessage('Admin agregado');
      setNewAdminUid('');
      await loadAdmins();
      onShowNotification && onShowNotification('Admin agregado');
    } catch (err) {
      console.error('Error agregando admin', err);
      setMessage(err.message || 'Error agregando admin');
    } finally { setBusy(false); }
  };

  const removeAdmin = async (uid) => {
    setBusy(true); setMessage('');
    try {
      await sb.deleteAdminRemote(uid);
      setMessage('Admin eliminado');
      await loadAdmins();
      onShowNotification && onShowNotification('Admin eliminado');
    } catch (err) {
      console.error('Error eliminando admin', err);
      setMessage(err.message || 'Error eliminando admin');
    } finally { setBusy(false); }
  };

  if (!isAdmin) return null;

  return (
    <div className="mb-6 p-4 border rounded bg-white">
      <h3 className="text-lg font-semibold mb-2">Gestión de administradores</h3>
      <p className="text-sm mb-2">Los administradores deben ser agregados por otro administrador. Proporciona el UID del usuario.</p>
      <div className="flex space-x-2 mb-3">
        <input value={newAdminUid} onChange={(e)=>setNewAdminUid(e.target.value)} placeholder="UID del nuevo admin" className="flex-1 px-3 py-2 border rounded" />
        <button onClick={addAdminByUid} disabled={busy} className="px-3 py-2 bg-green-600 text-white rounded">Agregar</button>
      </div>
      {message && <div className="text-sm text-gray-700 mb-2">{message}</div>}

      <h4 className="font-medium mb-2">Admins actuales</h4>
      <ul className="space-y-2">
        {admins.map(a => (
          <li key={a.id} className="flex justify-between items-center border rounded p-2">
            <div><code className="text-sm">{a.id}</code></div>
            <div><button onClick={() => removeAdmin(a.id)} className="px-2 py-1 bg-red-500 text-white rounded">Eliminar</button></div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AdminTools;
